// extracted by mini-css-extract-plugin
module.exports = {"timezone":"TimezoneAreaZonesDialog_timezone_3k8W0","time":"TimezoneAreaZonesDialog_time_1OHA0"};